import React from 'react';

/** @type {React.Context<XRayGeneratorControllerManager>} */
const XRayGeneratorManagerContext = React.createContext(undefined);

export default XRayGeneratorManagerContext;
